const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_COMMON_AM10010: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10010',
						hint: [],
					},				
				},
			},
			ZZ2: {
				name: ['薪資報表', 'Salary report', '薪资报表'],
				children: {
					ZZ_SYUGUANG_PB00101: {
						name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'],
						url: '/zz_common_pb10020',
						hint: [],
						ZZ_SYUGUANG_PB00101: { name: ['薪資明細表表頭設定', 'Salary statement header setup', '薪资明细表表头设置'] },
					},
					ZZ_SYUGUANG_PB00102: {
						name: ['薪資報表', 'Salary report', '薪资报表'],
						url: '/zz_common_pb10021',
						hint: [],
						ZZ_SYUGUANG_PB00102: { name: ['薪資報表', 'Salary report', '薪资报表'] }, 
					},					
				},
			},
			ZZ3: {
				name: ['薪資', 'Payroll', '薪资'],
				children: {
					ZZ_PB_SECTION_ALLOWANCE_CARDTIME: {
            name: ['(客製)輪班津貼計算', '(Customize)Allowance Calculation', '(客制)轮班津贴计算'],
            url: '/zz_pb_section_allowance_cardtime',
            hint: [],
          },
          ZZ_SEALKING_SALARY_ADVANCE: {
            name: ['(客製)薪資預支', '(Customize)Salary Advance', '(客制)薪资预支'],
            url: '/zz_sealking_salary_advance',
            hint: [],
          },
				},
			},
			ZZ4: {
				name: ['出勤報表', 'Attendance report', '出勤报表'],
				children: {
					ZZ_SEALKING_AM70031: {
						name: ['(客製)加班假勤工時統計表', '(客製)加班假勤工時統計表', '(客製)加班假勤工時統計表'],
						url: '/zz_sealking_am70031',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};